export default "__VITE_ASSET__DZOOh61q__"